import { render, staticRenderFns } from "./SelectGame.vue?vue&type=template&id=8a5ac366&scoped=true&"
import script from "./SelectGame.vue?vue&type=script&lang=ts&"
export * from "./SelectGame.vue?vue&type=script&lang=ts&"
import style0 from "./SelectGame.vue?vue&type=style&index=0&id=8a5ac366&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a5ac366",
  null
  
)

component.options.__file = "SelectGame.vue"
export default component.exports